import { useSelector } from 'react-redux';

import { selectPage } from '../../../selectors/analytics';
import { IPromoPopup, IPromoPopupNewbuildingLink } from '../../../types/promosPage';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getNewbuildingCardUrl } from '../../../utils/urls/getNewbuildingCardUrl';

export const useNewbuildingLinks = (promoDetails: IPromoPopup | null): IPromoPopupNewbuildingLink[] => {
  const { config } = useApplicationContext();
  const { siteType } = useSelector(selectPage);

  if (!promoDetails) {
    return [];
  }

  return promoDetails.newbuildingLinks.map(link => ({
    ...link,
    url: getNewbuildingCardUrl({
      baseUrl: link.url,
      uniquePromoId: promoDetails.uniqueId,
      siteType,
      config,
    }),
  }));
};
